const root = 'https://docs.wandb.ai';

// Use this directly if you know the name of the docUrl you want.
const DOC_URLS = {
  artifacts: root + '/guides/artifacts',
  artifactAutomations:
    root +
    '/models/automations/create-automations/webhook#create-a-webhook-automation',
  artifactTTL: root + '/guides/artifacts/ttl',
  automation: root + '/models/automations',
  codeComparer: root + '/guides/app/features/panels/code#code-comparer',
  codeSaving: root + '/guides/app/features/panels/code',
  compareMetrics: root + '/guides/app/features/panels/line-plot',
  config: root + '/guides/track/config',
  createQueue: root + '/platform/launch/create-launch-job#create-a-launch-job',
  customCharts: root + '/guides/app/features/custom-charts',
  defineMetric: root + '/guides/track/log#customize-the-summary',
  domainCapture:
    root +
    '/guides/hosting/iam/access-management/manage-organization/#domain-capture',
  gettingStarted: root + '/quickstart',
  launch: root + '/platform/launch/set-up-launch',
  launchPublicQueue: root + '/models/launch',
  launchJobs: root + '/platform/launch/create-launch-job#create-a-launch-job',
  launchJobsCreate:
    root + '/platform/launch/create-launch-job#create-a-launch-job',
  launchKubernetes: root + '/platform/launch/setup-launch-kubernetes',
  launchSageMakerAgentConfiguration:
    root +
    '/platform/launch/setup-launch-sagemaker#tutorial-set-up-w-and-b-launch-on-sagemaker',
  launchVertex: root + '/guides/launch/setup-vertex',
  logs: root + '/guides/track/log',
  logsDistributedSingleRun:
    root +
    '/guides/track/log/distributed-training/#track-all-processes-to-a-single-run',
  modelRegistry: root + '/guides/core/registry/model_registry/',
  models: root + '/guides/models/',
  parameterImportance:
    root + '/guides/app/features/panels/parameter-importance',
  'query-panel': root + '/guides/app/features/panels/query-panels/',
  publicApi: root + '/ref/python/public-api',
  pythonApi: root + '/ref/python/public-api',
  registry: root + '/guides/core/registry/',
  reports: root + '/guides/reports',
  root,
  save: root + '/guides/track/save-restore',
  serviceAccounts: root + '/guides/hosting/iam/service-accounts',
  summaryMetric: root + '/guides/track/log#summary-metrics',
  sweeps: root + '/guides/sweeps',
  sweepsOnLaunch: root + '/guides/launch/sweeps-on-launch',
  teams: root + '/platform/app/settings-page/teams',
  userSettings: root + '/platform/app/settings-page/user-settings',
  weave: root + '/weave/guides/tools/weave-in-workspaces#use-weave-panels',
  'weave-table': root + '/guides/tables',
  weaveProduct:
    'https://wandb.github.io/weave/?utm_source=app&utm_medium=app&utm_campaign=weave-nudge',
};

// Use this if you need an index lookup
export function lookupDocUrl(name: string) {
  return (DOC_URLS as {[key: string]: string | undefined})[name];
}

export default DOC_URLS;
